import { slickNSlide } from '../productDisplay/_maltImgSwipe';
import { quickConvert } from '../international/_intl';
import { replaceImage } from '../productDisplay/_images';
import Cookies from 'js-cookie';

const oneColorSwatchSelect = () => {
	$(document).ready(function () {
		if ($('.color-select-group').children('.one-option').length > 0) {
			var one = $('.color-select-group').children('.one-option');
			one.parents('.color-select-group').siblings('.swatch-item-container').find('img').addClass('swatch-selected');
		}
	});
};

const setSelected = (that) => {
	$(that).prop('selected', true);
};

const createPinterestLink = (imgProd, that) => {
	let prodSplit = imgProd.split('/main/').join('/zoom/'),
		pinLink = $('.share-pinterest').find('a').attr('href').split('//')[1].split('?')[1];
	that
		.parents('#content-wrapper')
		.find('.pinterest.product-share')
		.attr('href', `http://pinterest.com/pin/create/button/?${pinLink}${prodSplit}&amp;description=%20%23Dillards`);
};

const allDevicesSwatchClick = () => {
	$('.swatch-list li').on('keydown', function () {
		//Added for ADA purposes
		var swatchEnter = $(this);
		if (event.keyCode == 13) {
			swatchEnter.click();
		}
	});
	$('.swatch-list li').on('click', function () {
		var $selectBoxes = $('select.form-control').not($('.quantity-select'));
		var $form = $($selectBoxes).parents('form');
		if ($form.parents().hasClass('product-select-boxes')) {
			//Don't want to remove swatch-selected for all on bundle pages
			$('.swatch-list li img').removeClass('swatch-selected');
		}
		$(this).children('img').toggleClass('swatch-selected').parents().siblings().children().removeClass('swatch-selected');
		var swatchColorSelected = $(this).children('img').data('colorname') ? String($(this).children('img').data('colorname')) : undefined;
		$.each($(this).children('img').parents('form').find('select.color-select').find('option'), function () {
			if (String($(this).data('attrvalue')) == swatchColorSelected) {
				$(this).parent().parent().removeClass('has-error').tooltip('destroy').data('fieldValid', false);
				$(this).parent('select').val($(this).attr('value')).trigger('change');
			}
			$(this).children('img').trigger('blur');
		});
		var imgProd = '';
		if (!$('.desktopPage').length > 0) {
			let activeImg = $('div.chunk.slick-active img');
			imgProd = activeImg.attr('src') !== '' ? activeImg.attr('src') : activeImg.data('alts');
		} else imgProd = $('.mainProductImage').find('.mainImage').attr('src');
		createPinterestLink(imgProd, $(this));
		//Product Page Flat size-select
		var thisColor = $(this).children('img').data('colorname'),
			SizeSelected = $('.size-select-group-flat > ul > li').hasClass('size-selected'),
			DisabledSize = $('.size-select-group-flat > ul > li').hasClass('DisabledFlatSize');
		// $('.size-select-flat li').addClass("DisabledFlatSize");
		$('.size-select-group-flat > ul > li').each(function () {
			//if you have a size slected and then select a swatch the size will update to check if it needs to add the class 'has-error' or remove class 'has-error'
			if ($(this).hasClass('size-selected')) {
				$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').removeClass('has-error');
				setSelected(`.size-select option[value="${$('.size-selected').attr('value')}"]`);
			}
			if ($(this).hasClass('size-selected') && $(this).hasClass('DisabledFlatSize')) {
				$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').addClass('has-error');
				setSelected('.size-select option:eq(0)');
			}
		});
		$('.color-select-group .popover-error').remove();
	});

	// Below specifically for item attr page
	$('.preview-color-container ul.swatch-list li img').click(function () {
		var swatchColorSelected = $(this).data('fullimage'),
			colorName = $(this).attr('title');
		$(this).parents('.preview-color-container').find('img').not(this).css('border-color', '');
		var imgProd = '';
		if (!$('.desktopPage').length > 0) {
			slickNSlide(swatchColorSelected);
			let activeImg = $('div.chunk.slick-active img');
			imgProd = activeImg.attr('src') !== '' ? activeImg.attr('src') : activeImg.data('alts');
		} else {
			replaceImage($(this).parents('.container').find('.mainImage:eq(0)'), swatchColorSelected);
			imgProd = $('.mainProductImage').find('.mainImage').attr('src');
		}
		$('.preview-color-container p').text(`Preview Color: ${colorName}`);
		$(this).css('border-color', 'black');
		createPinterestLink(imgProd, $(this));
		$('.mainProductImage')
			.find('.mainImage')
			.attr('alt', `${colorName}:${$('#product-title').text()}`);
	});
};

const theFlats = (that, oneOption) => {
	var sizePrice = that.data('othersprice'),
		swatchColorSelected = $('.swatch-selected').data('colorname'),
		yourPrice = '';
	$(sizePrice.split('|')).each(function () {
		if (this.split(':')[0] == swatchColorSelected) {
			yourPrice = this.split(':')[1];
		}
	});

	var currency = $('.price-number').text(),
		currencyFinal = currency.substring(0, currency.search(/\d/)),
		priceVal = Cookies.get('zCountry') == 'US' ? yourPrice : quickConvert(yourPrice),
		sizePriceContainer = $(`<span class='thisPrice'>$${priceVal}</span>`);
	$('.thisPrice').remove();
	$('.shipping-message').hide();
	var showShipsFreeThreshold = $('[data-showshipsfree]').length > 0 ? $('[data-showshipsfree]').data('showshipsfree') : 999999;

	//Below is for changing the price displayed
	if ($('.swatch-selected').length > 0) {
		if ($('.original-price').length > 0) {
			var origPrice = $('header .original-price .price-number').text();
			var origPriceIndex = origPrice.lastIndexOf('$');
			var origPriceFinal = origPrice.substring(origPriceIndex + 1);

			if ($('.swatch-selected').parents().parents().siblings().hasClass('price-wrapper') > 0 && origPriceFinal != priceVal) {
				$('.thisPrice').remove();
				$('.thisSalePrice').remove();
				$('#mainPrice .price-wrapper').show();
				$('#mainPrice .now-price').addClass('orgNowPrice');
				$('.orgNowPrice').hide();
				$('#mainPrice .price-wrapper').append($(`<span class="thisSalePrice price now-price">Now<span class="price-number">$${priceVal}</span></span>`));
			} else {
				$(sizePriceContainer).insertBefore($('#mainPrice .price-wrapper'));
				if (yourPrice >= showShipsFreeThreshold) {
					$('.shipping-message').show();
				}
				$('#mainPrice .price-wrapper').hide();
			}
			if (yourPrice == '') {
				$('.thisPrice').remove();
				$('#mainPrice .price-wrapper').show();
				$('.orgNowPrice').show();
				$('.thisSalePrice').hide();
			}
		} else {
			$('#mainPrice.price-wrapper .price').prepend(sizePriceContainer);
			if (yourPrice >= showShipsFreeThreshold) {
				$('.shipping-message').show();
			}
			$('#mainPrice .price-number').hide();

			if ($('.size-selected').length === 0) {
				$('#mainPrice .price-number').show();
			}
		}

		if ($('.original-price').length == 0 && $('.now-price').length == 0) {
			if ($('.size-selected').hasClass('DisabledFlatSize')) {
				$('.thisPrice').remove();
				$('.price-number').show();
			}
		}
	} else {
		if ($('.size-selected').length > 0) {
			$('.sizePrice').remove();
			$('.price-wrapper').hide();
			var sizePriceString = sizePrice.toString();
			var priceNum = sizePriceString.substring(sizePriceString.indexOf(':') + 1);
			$(
				`<span class="price-number sizePrice" style="font-size:13px;font-family:'Open Sans', sans-serif;margin-bottom: 5px;display:block;">$${priceNum}</span>`
			).insertAfter($('.price-wrapper'));
		} else {
			$('.sizePrice').remove();
			$('.price-wrapper').show();
		}
	}
	//End of changing the price displayed
};

const flatSizeClick = () => {
	$('.size-select-flat li').on('keydown', function () {
		//Added for ADA purposes
		var sizeEnter = $(this);
		if (event.keyCode == 13) {
			sizeEnter.click();
		}
	});
	$('.size-select-flat li').on('touchstart click', function () {
		if ($('.size-select-flat li.size-selected').length == 0) {
			$.each($('.size-select-flat li'), function () {
				$(this).removeClass('flat-size-error');
			});
		}

		if (!$(this).hasClass('size-selected')) {
			$(this).addClass('size-selected');
		}
		$(this).siblings().removeClass('size-selected');

		// Below is for displaying price of size selected above the add to bag(only for items with a price range)
		if ($(this).data('othersprice') && $('.swatch-list li img').hasClass('swatch-selected')) theFlats($(this), false);
		if ($(this).data('othersprice') && $('.color-select-group p').hasClass('one-option')) theFlats($(this), true);
		// End for displaying price of size selected above the add to bag

		//Add the strike through
		$('.swatch-list li').prepend("<span class='swatch-disabled'></span>");

		var sizeClicked = $(this).attr('data-attrvalue');
		$('.color-select option:not(:contains(Color))').each(function () {
			var thisOption = $(this);
			var sizeAvForColor = $(this).attr('data-others');
			var sizesArray = sizeAvForColor.split('|');
			if (sizesArray.indexOf(sizeClicked) !== -1) {
				var colorMatch = thisOption.attr('data-attrvalue');
				$('.swatch-list li img').each(function () {
					if ($(this).attr('data-colorname') === colorMatch) {
						$(this).siblings().remove();
					}
				});
			}
		});

		if ($('.color-select-group p').hasClass('one-option')) {
			$('.swatch-list li img').siblings().remove();
		}

		var SizeSelected = $(this).hasClass('size-selected'),
			DisabledSize = $(this).hasClass('DisabledFlatSize');
		if ($(this).hasClass('size-selected')) setSelected(`.size-select option[value="${$(this).attr('value')}"]`);
		else {
			setSelected('.size-select option:eq(0)');
			$('.swatch-list li img').siblings().remove();
			$('.thisPrice').remove();
			$('#mainPrice .price-wrapper').show();
			$('.thisSalePrice').remove();
			$('.orgNowPrice').show();
		}
		if ($(this).hasClass('DisabledFlatSize')) setSelected('.size-select option:eq(0)');
		if (SizeSelected && !DisabledSize) {
			$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').removeClass('has-error');
			$('.size-select-group-flat .popover-error').remove();
		}
		if (SizeSelected && DisabledSize) {
			$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').addClass('has-error');
			$(this).tooltip('show');
			let tooltipID = $(this).attr('aria-describedby');
			setTimeout(function () {
				$(`#${tooltipID}`).remove();
			}, 2000);
		}
		if (!$(this).hasClass('flat-size-error')) {
			$.each($('.size-select-flat li'), function () {
				$(this).removeClass('flat-size-error');
			});
		}
		$.each($('.size-select-flat li'), function () {
			//ADA
			var $this = $(this);
			$this.hasClass('size-selected') ? $this.attr('aria-selected', 'true') : $this.attr('aria-selected', 'false');
		});
		return false;
	});
};

const flatSizeResize = () => {
	$(document).ready(function () {
		var widest = 0;
		var highest = 0;
		$('.size-select-flat li')
			.each(function () {
				widest = Math.max(widest, $(this).width() + 1);
			})
		.width(widest);
		$('.size-select-flat li')
			.each(function () {
				highest = Math.max(highest, $(this).height() + 1);
			})
		.height(highest);
	});
};

export { allDevicesSwatchClick, flatSizeClick, flatSizeResize, oneColorSwatchSelect, theFlats };
